var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Vue, Component, Watch } from "vue-facing-decorator";
import { BlockTypesClient, GetBlockTypeListPaginatedQuery, PaginatedEnumerableOfBlockTypeModel, BlockTypeModel, UpdateBlockTypeCommand, CreateBlockTypeCommand } from "@/app/api/battery-portal-api";
import { Notifier } from "@/common/utils/notifier";
import { HttpHelper } from "@/app/utils/http-helper";
const blockTypeClient = new BlockTypesClient(window.apiUrl);
let BlockTypesVue = class BlockTypesVue extends Vue {
    constructor() {
        super(...arguments);
        // simpletons
        this.working = false;
        this.searchAttempted = false;
        // models
        this.query = new GetBlockTypeListPaginatedQuery({
            pageNo: 1,
            pageSize: 100,
        });
        this.data = new PaginatedEnumerableOfBlockTypeModel();
    }
    created() {
        this.search();
    }
    ;
    // get
    search() {
        if (this.working)
            return;
        if (!this.query)
            return;
        this.working = true;
        blockTypeClient
            .getListPaginated(this.query)
            .then(response => {
            if (!response)
                return;
            this.data = response;
            this.query.pageNo = this.data.displayedPage;
            this.query.pageSize = this.data.pageSize;
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
            this.searchAttempted = true;
        });
    }
    ;
    // set
    add() {
        let blockType = new BlockTypeModel({
            blockTypeId: 0,
            blockTypeName: ""
        });
        if (!this.data.records)
            this.data.records = new Array();
        this.data.records.unshift(blockType);
    }
    ;
    save(blockType) {
        if (!blockType.blockTypeName) {
            Notifier.onError("Please enter a block type.");
            return;
        }
        let promise = () => {
            return blockType.blockTypeId
                ? blockTypeClient.update(blockType.blockTypeId, new UpdateBlockTypeCommand({ requestModel: blockType }))
                : blockTypeClient.add(new CreateBlockTypeCommand({ requestModel: blockType }));
        };
        promise()
            .then(() => {
            Notifier.onOk(this);
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.search();
        });
    }
    ;
    purge(blockType) {
        if (!blockType.blockTypeId && this.data.records) {
            this.data.records.splice(this.data.records.indexOf(blockType), 1);
            return;
        }
        this.$confirmModal.show("Are you sure that you want to permanently delete this block type? This action cannot be undone.", { title: "Please confirm" })
            .then((value) => {
            if (!value)
                return;
            blockTypeClient
                .delete(blockType.blockTypeId)
                .then(() => {
                Notifier.onOk();
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.search();
            });
        });
    }
    ;
    // computed
    get noData() {
        return this.searchAttempted && (!this.data || !this.data.records || !this.data.records.length);
    }
    ;
};
__decorate([
    Watch("query.pageNo"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], BlockTypesVue.prototype, "search", null);
BlockTypesVue = __decorate([
    Component({
        name: "BlockTypesVue"
    })
], BlockTypesVue);
export default BlockTypesVue;
